
<template>
  <div>
    <div class="outmain ba_f">
      <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>{{ $t('plugin.bond.title') }}</span>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('plugin.bond.list')" name="1">
          <span slot="label">{{ $t('plugin.bond.list') }}</span>
        </el-tab-pane>
        <el-tab-pane :label="$t('plugin.bond.settingsTab')" name="2">
          <span slot="label">{{ $t('plugin.bond.settingsTab') }}</span>
        </el-tab-pane>
      </el-tabs>
      <div class="mar_t20">
        <el-form ref="form" :model="form" label-width="130px">
          <div v-if="form.isOpen=='1'">
            <el-form-item :label="$t('plugin.bond.settings.customName')" :required="true">
              <el-input v-model.trim="form.customName" autocomplete="off" :placeholder="$t('plugin.bond.settings.customNamePh')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('plugin.bond.settings.amount')" :required="true">
              <el-input v-model.trim="form.money" autocomplete="off" :placeholder="$t('plugin.bond.settings.amountPh')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('plugin.bond.settings.refund')" :required="true">
              <el-radio-group v-model="form.isRefund">
                <el-radio :label="1">{{ $t('common.enable') }}</el-radio>
                <el-radio :label="2">{{ $t('common.disable') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('plugin.bond.settings.refundDays')" :required="true">
              <el-input v-model.trim="form.day" autocomplete="off" :placeholder="$t('plugin.bond.settings.refundDaysPh')">
                <template slot="append">{{ $t('plugin.bond.settings.dayUnit') }}</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('plugin.bond.settings.agreement')" :required="true">
              <el-input type="textarea" v-model.trim="form.agreement" autocomplete="off" :placeholder="$t('plugin.bond.settings.agreementPh')" rows="4"></el-input>
            </el-form-item>
            <el-form-item :label="$t('plugin.bond.settings.explain')" :required="true">
              <el-input type="textarea" v-model.trim="form.explain" autocomplete="off" :placeholder="$t('plugin.bond.settings.explainPh')" rows="4"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div class="mar_t20 ba_f pad_20 t_c">
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </div>
  </div>
</template>
<script>
import { getConfig, postConfig } from '@/api/set';
export default {
  data() {
    return {
      activeName: '2',
      radio: '',
      form: {
        isOpen: '1',
        userName: '',
        isRefund: 1,
        customName: '',
        money: '',
        agreement: '',
        explain: '',
        day: ''
      },
      options: [
        {
          value: '0',
          label: '微信'
        },
        {
          value: '1',
          label: '手动打款'
        }
      ]
    };
  },
  created() {
    this.init();
  },
  methods: {
    handleClick() {
      if (this.activeName == '1') {
        this.$router.push({ name: 'bondlist' });
      }
    },
    init() {
      getConfig({ ident: 'bond' }).then((res) => {
        if (res.code == 1) {
          Object.assign(this.form, res.data);
        }
      });
    },
    submitForm() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.form.ident = 'bond';
          postConfig(this.form).then((res) => {
            if (res.code == 1) {
              this.$baseMessage(res.msg, 'success');
              this.init();
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="sass" scoped>
</style>
